<ng-template #collSearch style="background-color:burlywood">
  <div class="modal-header headerBackground">
    <h4 class="modal-title pull-left ">Collection Search</h4>
    <button type="button " class="close pull-right" aria-label="Close" (click)="modalRef.hide();">
      <span aria-hidden="true ">&times;</span>
    </button>
  </div>
  <div class="row padding-1">
      <div class="form-group col-md-12 padding-top">
      <div class="input-group mb-3">
      <input #iesearch [(ngModel)]="collSearchText" type="text" class="form-control" placeholder="Suchetext..." aria-describedby="search"
         (keyup.enter)="collSearchTextChange()" />
         <div class="input-group mb-3">
          <select name="collectionTyp" [(ngModel)]="collectionTyp" placeholder="Typ..."  class="form-select" id="CollectionType" (change)="collSearchTextChange()">
            <option *ngFor="let collTypeItem of collTypeItems; let i = index" [value]="collTypeItems[i].id">
              {{collTypeItems[i].name}}
            </option>
          </select>
        </div>
              <div class="input-group-append" (click)="collSearchTextChange()">
        <button class="btn btn-sm btn-outline-secondary" id="search"  type="submit" (click)="collSearchTextChange()">
          <i id="button_Search"></i>
        </button>
      </div>
    </div>
    </div>
  </div>
  <div class="row  padding-1">
    <div class="col-md-12">
      <div class="table-responsive">
        <table class="table table-sm table-striped">
          <thead class="thead-dark">
            <tr>
              <th scope="col">
                Displayname
              </th>
            </tr>
          </thead>
          <tbody id="collItems">
            <tr scope="row" *ngFor="let collItem of collItems.value; let i = index;" [class.table-danger]="i==selectedRowCol" (click)="setActiveRowCol(i)">
              <td>{{collItem.Name}}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pager-pos" *ngIf="collItems.rowCount > collItems.rowsPerPage">
          <ngb-pagination #currentPageCollection [collectionSize]="collItems.rowCount" [(page)]="collItems.activePage" [pageSize]="collItems.rowsPerPage"
          [boundaryLinks]="true" size="sm" (pageChange)="collPageChange(currentPageCollection);"></ngb-pagination>
        </div>
  
        <div class="btn-sm">
            <button type="button" (click)="addToCollection();modalRef.hide()" class="btn btn-warning btn-sm">
                Add to Collection
            </button>
        </div>
    </div>
    </div>
  </div>
  </ng-template>